import * as THREE from "three";

const loadingManager = new THREE.LoadingManager()

const loaderText = document.getElementById('loader-text')
const loaderDiv = document.getElementById('loader')
const isIOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;


loadingManager.onProgress = (url, itemsLoaded, itemsTotal) => {
    const percent = Math.floor((itemsLoaded / itemsTotal) * 100)
    loaderText.innerText = percent + '%';
};

loadingManager.onLoad = () => {
    setTimeout(() => {
        loaderDiv.style.display = 'none'

        const urlParams = new URLSearchParams(window.location.search);

        if (urlParams.get('ar') === 'true') {
            const startOverlay = document.createElement('div');
            startOverlay.innerHTML = `
            <div id="overlay">
                <button id="auto-ar-btn">
                    START AR
                </button>
            </div>
        `;
            document.body.appendChild(startOverlay);

            document.getElementById('auto-ar-btn').addEventListener('click', () => {
                const arButton = isIOS ? document.querySelector('#ARButtonIOS'): document.querySelector('#ARButton');

                if (arButton) {
                    arButton.click();
                }
                startOverlay.remove();
            });
        }
    }, 500)
};

export default loadingManager;